import { CoverDto } from './CoverDto';
import { GenderEnum } from '../../enums/GenderEnum';

export class InsuredAttributesDto {
  dateOfBirth: Date;
  isSmoker: boolean;
  gender: string;
  covers: CoverDto[] = [new CoverDto()];
}

export class InsuredAttributesDtoExtended extends InsuredAttributesDto {
  occupation: string;
  gender: GenderEnum;
}
